(function (angular) {
    'use strict';

    angular.module('chat2')
        .factory('chatClientFactory', ["$rootScope", "$injector", "comapiChatStore", "portalConfig",
            function ($rootScope, $injector, comapiChatStore, portalConfig) {

                // This will be cached when we initialise the sdk 
                var webSocketManager;


                // someone has logged out
                $rootScope.$on('jwtService.clear', function (event) {
                    if (fac.chatClient) {
                        fac.chatClient.uninitialise()
                            .then(function (result) {
                                webSocketManager = fac.chatClient = undefined;
                            });
                    }
                });

                $rootScope.$on("jwtService.refresh", function (event, token) {

                    if (webSocketManager) {

                        webSocketManager.disconnect()
                            .then(function () {
                                connectWithRetry();
                            })
                    }
                });

                var attempts = 0;
                function connectWithRetry() {

                    var time = webSocketManager.generateInterval(attempts);

                    setTimeout(function () {
                        attempts++;
                        webSocketManager.connect()
                            .then(function () {
                                attempts = 0;
                            })
                            .catch(function (e) {
                                console.warn("socket recycle failed", e);
                                connectWithRetry();
                            });

                    }, time);
                }


                var fac = {
                    /**
                     * 
                     */
                    create: function (apiSpaceId) {
                        // pull all these in with the $injector for tidiness ...
                        var foundationRestUrls = $injector.get('FoundationRestUrls');
                        var sessionManager = $injector.get('SessionManager');
                        var conversationManager = $injector.get('ConversationManager');
                        var eventMapper = $injector.get('EventMapper');
                        var messageManager = $injector.get('MessageManager');

                        var eventMapping = {
                            conversation: ["conversation", "chat"],
                            conversationMessage: ["conversationMessage", "chatMessage"],
                            profile: ["profile"]
                        };

                        var interfaceContainer = new COMAPI_CHAT.InterfaceContainer();
                        interfaceContainer.initialise();

                        comapiChatStore.setApiSpace(apiSpaceId);

                        fac.chatConfig = new COMAPI_CHAT.ComapiChatConfig()
                            .withStore(comapiChatStore)
                            .withApiSpace(apiSpaceId)
                            .withUrlBase(portalConfig.urlBase)
                            .withMessagePageSize(10)
                            .withWebSocketBase(portalConfig.urlBase.replace("http", "ws"))
                            .withFoundationRestUrls(foundationRestUrls)
                            .withEventMapping(eventMapping)
                            .withLazyLoadThreshold(0)
                            .withAutoSynchronize(false)
                            .withLogLevel(3)

                        fac.chatConfig.interfaceContainer = interfaceContainer;

                        interfaceContainer.bindComapiConfig(fac.chatConfig);

                        var stockEventMapper = interfaceContainer.getInterface("EventMapper");

                        eventMapper.initialise(stockEventMapper);
                        interfaceContainer.setInterface("EventMapper", eventMapper);

                        interfaceContainer.setInterface("SessionManager", sessionManager);

                        webSocketManager = interfaceContainer.getInterface("WebSocketManager");

                        var stockConversationManager = interfaceContainer.getInterface("ConversationManager");
                        conversationManager.initialise(fac.chatConfig, interfaceContainer.getInterface("AuthenticatedRestClient"), interfaceContainer.getInterface("NetworkManager"), stockConversationManager);
                        interfaceContainer.setInterface("ConversationManager", conversationManager);

                        var stockMessageManager = interfaceContainer.getInterface("MessageManager");
                        messageManager.initialise(stockMessageManager);
                        interfaceContainer.setInterface("MessageManager", messageManager);

                        return new COMAPI_CHAT.ComapiChatClient();
                    }
                };

                return fac;

            }]);

})(window.angular);
